import { useEffect, useState } from 'react'

// Значение с задержкой — гасит частые изменения (ввод в поиск): запрос уходит
// не на каждую букву.
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(id)
  }, [value, delayMs])
  return debounced
}
